<app-command [command]="submit$" (success)="saved()">
  <app-details-modal
    [title]="TextAttributes.SubmitOpportunityTitle | customText"
    saveLabel="Submit"
    [form]="submitForm"
    (cancel)="cancel()"
    [showSave]="showSave"
    (save)="submit()">
    <app-details-content>
      <ng-container *appLoad="let load of load$">
        <ng-container
          [ngTemplateOutlet]="requiredDocumentsNotGenerated"
          [ngTemplateOutletContext]="{
            invalidDocuments: load.opportunitySummary | invalidRequiredDocuments
          }"></ng-container>
        <form [formGroup]="submitForm">
          <h4>Product to submit</h4>
          <div class="row mb-3">
            <div class="col">
              <ng-container *ngIf="load.productSelection; else noProduct">
                <ng-container *ngIf="load.productSelection | invalidProduct">
                  <lds-inline-message
                    appearance="error"
                    message="Unfortunately it looks like the recommended option contains products that are no longer available. These have been highlighted and should be reviewed.">
                  </lds-inline-message>
                </ng-container>
                <app-product-selection-display
                  [productSelection]="
                    load.productSelection
                  "></app-product-selection-display>
              </ng-container>
              <ng-template #noProduct>
                <lds-alert
                  [message]="TextAttributes.SubmissionProductRecommendationRequired | customText"
                  appearance="warning"
                  type="informational">
                </lds-alert>
              </ng-template>
            </div>
          </div>
          <h4>Submission notes</h4>
          <div class="row mb-3">
            <div class="col">
              <lds-form-field>
                <lds-label>Summary</lds-label>
                <lds-form-hint alignment="right">Optional</lds-form-hint>
                <lds-text-area
                  formControlName="summary"
                  placeholder="summary"
                  [rows]="5"
                  [maxlength]="4000">
                </lds-text-area>
              </lds-form-field>
            </div>
          </div>
          <ng-container
            *ngIf="load.productSelection | hasSubmissionQuestionnaire">
            <h4>Additional responsible lending questions</h4>
            <div class="row mb-3">
              <div class="col">
                <app-questionnaire-form
                  [questions]="load.questionnaire.questions"
                  [flowRules]="load.questionnaire.flowRules"
                  [editMode]="true"
                  [questionnaireForm]="questionnaireForm"
                  size="sm"
                  [required]="true">
                </app-questionnaire-form>
              </div>
            </div>
          </ng-container>
        </form>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>

<ng-template
  #requiredDocumentsNotGenerated
  let-invalidDocuments="invalidDocuments">
  <ng-container *ngIf="!(invalidDocuments | empty)">
    <app-inline-message
      appearance="warning"
      headline="Required documents have not been generated">
      <app-inline-message-content>
        <span
          >{{ invalidDocuments.length | plural : 'document needs' : 'documents need' }} to be generated before the opportunity can be submitted.</span
        >
        <ul class="message__list">
          <li *ngFor="let item of invalidDocuments">
            {{ item.documentName }}
          </li>
        </ul>
      </app-inline-message-content>
    </app-inline-message>
  </ng-container>
</ng-template>
